import { render } from "./rockover.vue?vue&type=template&id=bd20c456&scoped=true"
import script from "./rockover.vue?vue&type=script&lang=js"
export * from "./rockover.vue?vue&type=script&lang=js"

import "./rockover.vue?vue&type=style&index=0&id=bd20c456&scoped=true&lang=css"

import exportComponent from "C:\\src\\web\\finance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd20c456"]])

export default __exports__